import { useMemo } from "react";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import AutocompleteField from "../../../components/Form/AutocompleteField";
import { useTranslationApp } from "../../../lib/i18next";
import { ADMIN_PRIMARY_KPI_OPTIONS } from "../../../utils/options";
import { GLOBAL_REPORT_MEASURABLE_KPI_ALL } from "../../../i18n/keysTranslations";
import {
  BORDER_RADIUS_BUTTON,
  FONT_SIZE_BUTTON,
  FONT_WEIGHT_BUTTON,
} from "../../../utils/constants";
import { INPUT_COLOR_BORDER } from "../../../utils/colors";

const MeasurableKpiSelector = ({ control, disabled = false, errors = {} }) => {
  const { t } = useTranslationApp();

  const kpiOptions = useMemo(
    () =>
      ADMIN_PRIMARY_KPI_OPTIONS.map(({ value }) => ({
        value,
        label: value,
      })),
    []
  );

  return (
    <AutocompleteField
      name="measurableKpi"
      control={control}
      errors={errors}
      options={kpiOptions}
      doTranslate
      disabled={disabled}
      fullWidth={false}
      rules={{}}
      mode="text"
      showEmptyOption
      emptyOptionText={t(GLOBAL_REPORT_MEASURABLE_KPI_ALL)}
      defaultPlaceholderText={t(GLOBAL_REPORT_MEASURABLE_KPI_ALL)}
      onGetDisplayText={(field, options) => {
        if (!field?.value) {
          return t(GLOBAL_REPORT_MEASURABLE_KPI_ALL);
        }

        const selectedOption = options.find(
          (option) => option.value === field.value
        );

        return selectedOption ? t(selectedOption.label) : t(field.value);
      }}
      startIcon={
        <FilterListOutlinedIcon
          sx={{ fontSize: 14, color: "text.secondary" }}
        />
      }
      sx={{
        borderRadius: BORDER_RADIUS_BUTTON,
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        minWidth: "max-content",
        width: { xs: "100%", sm: "auto" },
        pl: 1.5,
        height: 48,
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
      sxText={{
        fontSize: FONT_SIZE_BUTTON,
        lineHeight: 1,
        fontWeight: FONT_WEIGHT_BUTTON,
      }}
    />
  );
};

export default MeasurableKpiSelector;
